// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"ef37858e","248":"ef37858e","483":"ef37858e","555":"ef37858e","714":"ef37858e","734":"ef37858e","865":"ef37858e","931":"ef37858e"}[chunkId] + ".chunk.css";
};